import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../../shared/baseUrl";
import { createNotification } from "../../components/Common/CreateNotification";

export const fetchRP = createAsyncThunk("recentproducts/get", async (data) => {
    var page = data.page ?? 1;
    var stateChange = data.stateChange ?? false;
    var selectedCity = data.selectedCity ?? { value: -1, label: "All" };
    var response = await fetch(baseUrl + `recently-added?page=${page}${selectedCity.value !== -1 ? `&city_id=${selectedCity.value}` : ''}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        }
    });
    var res = await response.json();
    return { res: res, stateChange: stateChange, isError: false, errorMessage: "Something went wrong." };

});

const recentProductSlice = createSlice({
    name: "recentProducts",
    initialState: {
        currentPage: 1,
        isRecentLoading: false,
        isFirst: true,
        recentProducts: [],
        isRecentError: false,
        forPagination: {},
    },
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRP.pending, (state) => {
            state.isRecentLoading = true;
            state.isRecentError = false;
        });
        builder.addCase(fetchRP.fulfilled, (state, action) => {
            if (action.payload.isError) {
                state.isRecentLoading = false;
                state.isRecentError = true;
                createNotification("error", action.payload.errorMessage);

            } else {
                if (action.payload.res.success) {
                    state.forPagination = action.payload.res.data;
                    if (action.payload.stateChange) {
                        state.recentProducts = action.payload.res.data.data;
                    } else {
                        state.recentProducts = [...state.recentProducts, ...action.payload.res.data.data];
                    }
                    state.isRecentLoading = false;
                    state.isFirst = false;
                }
                else {
                    createNotification("error", action.payload.res.message);
                    state.isRecentLoading = false;
                    state.isRecentError = true;
                }
            }
        })
        builder.addCase(fetchRP.rejected, (state) => {
            state.isRecentLoading = false;
            state.isRecentError = true;
        });
    },
});

export const { setCurrentPage } = recentProductSlice.actions;
export default recentProductSlice.reducer;